import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLAnchorElement} link
 *
 * @extends {Component<Refs>}
 */
class BackLinkComponent extends Component {
  requiredRefs = ['link'];

  /**
   * @param {Event} event
   */
  navigateBack = (event) => {
    event.preventDefault();

    const homeUrl = this.dataset.homeUrl || '/';
    const referrer = document.referrer;

    let hasInternalReferrer = false;

    if (referrer) {
      try {
        hasInternalReferrer = new URL(referrer).origin === window.location.origin;
      } catch {
        hasInternalReferrer = false;
      }
    }

    if (hasInternalReferrer && window.history.length > 1) {
      window.history.back();
      return;
    }

    window.location.assign(homeUrl);
  };
}

if (!customElements.get('back-link-component')) {
  customElements.define('back-link-component', BackLinkComponent);
}
